export default __webpack_public_path__ + "static/media/microsoftoffice.75a83b98.svg";